import React from 'react'
import Footer, { FooterContacts, FooterDevelopedBy } from '@blocks/Footer'

function MainFooter() {
    return <Footer />
}

export default React.memo(MainFooter)